






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'HelperOffset',
})
export default class extends Vue {
  @Prop({ default: false }) private fullWidth!: boolean;
  @Prop({ default: 0 }) private offset!: number | string;

  get classes() {
    return {
      'v-offset--full-width': this.fullWidth,
    };
  }

  get styles() {
    return {
      top: `-${this.offset}px`,
      marginBottom: `-${this.offset}px`,
    };
  }
}
